import { FormEvent } from "react"
import { EmployeeProps } from "./employee_type"
import { SubmittalProps } from "./submittal_types"
import { RFIProps } from "./rfi_types"
import { TaskProps } from "./tasks_types"
import { TaskProgressProps } from "./progress_types"
import { ClientMinProps } from "./client_types"
import { PointOfContactMinProps } from "./point-of-contact_types"
import { InvoiceProps } from "./invoices_types"

export type ProjectStatus =
    "Active" |
    "Hold" |
    "Review" |
    "Not Started" |
    "Completed" |
    "Cancelled"

export type ConstructionAdminServices = "No" | "Yes" | "Completed"

export const PROJECT_STATUS: ProjectStatus[] = [
    "Active",
    "Hold",
    "Review",
    "Not Started",
    "Completed",
    "Cancelled"
]

export type ProjectProps = {
    project_id?: string
    project_name: string
    manager?: EmployeeProps
    city?: string
    client_name?: string
    start_date?: string
    end_date?: string
    description?: string
    status?: ProjectStatus
    folder_location?: string
    template?: string,
    tasks?: TaskProps[],
    submittals?: SubmittalProps[],
    rfis?: RFIProps[],
    isDeadline: boolean
    point_of_contact?: string,
    consulting_fee?: number,
    no_date_due?: boolean // Used in the Project Form

    is_sent_to_quickbooks?: boolean // Typically altered by the Invoices
    payment_amount?: number // The invoice amount from the latest invoice
    latest_invoice?: InvoiceProps

    client?: ClientMinProps
    poc?: PointOfContactMinProps

    task_progress?: TaskProgressProps

    project_progress?: number
    total_quests?: number // The total amount of tasks, submittals, and RFIs for the project

    project_size?: number

    task_counts?: OverviewProps // This is used to show the task counts on the project row. Data retreived from the pagination API
    submittal_counts?: OverviewProps // This is used to show the submittal counts on the project row
    similar_projects?: SimilarProjectsProps[] // This is used to show the similar projects on the project row. Data retreived from the pagination API

    proposal_sent?: boolean // Used for Finance to check if the proposal has been sent to the azure file share
    construction_admin_services?: ConstructionAdminServices

    unneeded_template_ids?: number[]
    missing_required_templates_count?: number

    updated_at?: string
}

type DateOnly = string

// This is used for creating (as well as updating) a project
// Because why again?
export type ProjectFormCreationProps = {
    project_id?: string
    project_name: string
    manager: string // the email of the manager
    city: string
    client_name: string
    start_date: DateOnly
    end_date?: DateOnly
    description: string
    status: ProjectStatus
    template: string
    point_of_contact: string
    isDeadline: boolean
    no_date_due?: boolean
    project_size?: number
    consulting_fee?: number
    folder_location?: string
    proposal_sent?: boolean
    construction_admin_services?: ConstructionAdminServices
}

export type ProjectFilterProps = {
    filterText: string
    onFilter: (e: FormEvent<HTMLInputElement>) => void
    onClear: () => void
}

export type ProjectCreationProps = {
    project_count: number,
    users: string[]
    client_names: string[]
    cities: string[]
    current_user: string[]
}

type OverviewProps = {
    total: number
    completed: number
    category_counts: CategorySummaryProps
}

// This is used to show the category counts on the project row
// CategoryCountsProps shows the total and completed counts for each category and the unique assignees
type CategorySummaryProps = {
    Mechanical: CategoryCountsProps
    Electrical: CategoryCountsProps
    Plumbing: CategoryCountsProps
    "Fire Protection": CategoryCountsProps
    Other: CategoryCountsProps
}

type CategoryCountsProps = {
    total: number
    completed: number
    unique_assignees: string[] // This is used to show the unique assignees on the project row
}

// Smaller version of the ProjectProps that is used to show the similar projects on the project row. Data retreived from the pagination API
type SimilarProjectsProps = {
    project_id: string
    project_name: string
    template? : string
    client_name?: string
    city?: string
    status?: ProjectStatus
    folder_location?: string
}
